module.exports = __webpack_public_path__ + "static/media/linked-in-icon.f95a9933.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/linked-in-icon.png
 ** module id = 200
 ** module chunks = 0
 **/